module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Preface"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("Modern Warfare Series")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("P")]), _vm._v("en & Sword’s Modern Warfare series is designed to provide a visual account of the defining conflicts of the late twentieth and early twenty-first centuries. These include operations Desert Storm, Iraqi Freedom and Enduring Freedom. A key characteristic of all three, fought by coalitions, is what has been dubbed ‘shock and awe’, whereby superior technology, air supremacy and overwhelming firepower ensured complete freedom of manoeuvre on the ground in the face of a numerically stronger enemy. The focus of this series is to explain how military and political goals were achieved so swiftly and decisively.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another aspect of modern warfare is that it is conducted in the full glare of the international media. This is a trend that started during the Vietnam War, and today every aspect of a conflict is visually recorded and scrutinized. Such visual reporting often shapes public perceptions of conflict to a far greater extent than politicians or indeed generals.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All the photographs in this book, unless otherwise credited, were issued by the US department of defense and the UK’s ministry of defence at the time of the conflict. the author and the publishers are grateful for the work of the various forces’ combat photographers.")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6c04df6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Preface.vue
// module id = 69
// module chunks = 0